import { useEffect, useState } from 'react'
import Layout from './Layout'
import { listarAuditoria } from '../services/api'

const acaoCor = { CREATE:'#EAF3DE', READ:'#E6F1FB', UPDATE:'#FAEEDA', DELETE:'#FCEBEB' }
const acaoTC  = { CREATE:'#27500A', READ:'#0C447C', UPDATE:'#633806', DELETE:'#791F1F' }

export default function Auditoria() {
  const [registros, setRegistros] = useState([])
  const [total, setTotal] = useState(0)
  const [pagina, setPagina] = useState(1)
  const [load, setLoad] = useState(true)

  useEffect(() => { carregar() }, [pagina])

  async function carregar() {
    setLoad(true)
    try {
      const res = await listarAuditoria({ pagina, limite: 50 })
      setRegistros(res.data.registros || [])
      setTotal(res.data.total || 0)
    } catch {}
    setLoad(false)
  }

  return (
    <Layout>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontSize:18, fontWeight:500, margin:0 }}>Trilha de auditoria</h1>
        <div style={{ fontSize:13, color:'#9ca3af' }}>{total} registro{total!==1?'s':''} no total</div>
      </div>

      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        <div style={{ display:'grid', gridTemplateColumns:'140px 80px 100px 1fr 120px', gap:0, padding:'10px 16px', borderBottom:'1px solid #f3f4f6', fontSize:11, fontWeight:500, color:'#9ca3af', textTransform:'uppercase', letterSpacing:'0.4px' }}>
          <div>Data/hora</div>
          <div>Ação</div>
          <div>Tabela</div>
          <div>Usuário / Detalhes</div>
          <div>IP</div>
        </div>

        {load
          ? <div style={{ padding:32, textAlign:'center', color:'#9ca3af' }}>Carregando...</div>
          : registros.length === 0
            ? <div style={{ padding:32, textAlign:'center', color:'#9ca3af', fontSize:14 }}>Nenhum registro de auditoria ainda.</div>
            : registros.map((r,i) => (
              <div key={r.id} style={{
                display:'grid', gridTemplateColumns:'140px 80px 100px 1fr 120px', gap:0,
                padding:'10px 16px', borderBottom:i<registros.length-1?'1px solid #f9fafb':'none',
                fontSize:12
              }}>
                <div style={{ color:'#6b7280', fontFamily:'monospace', fontSize:11 }}>
                  {new Date(r.criado_em).toLocaleString('pt-BR',{day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit'})}
                </div>
                <div>
                  <span style={{ background:acaoCor[r.acao]||'#f3f4f6', color:acaoTC[r.acao]||'#374151', padding:'1px 6px', borderRadius:99, fontSize:10, fontWeight:500 }}>
                    {r.acao}
                  </span>
                </div>
                <div style={{ color:'#374151' }}>{r.tabela||'—'}</div>
                <div style={{ color:'#374151' }}>
                  <span style={{ fontWeight:500 }}>{r.usuario_nome||'Sistema'}</span>
                  {r.detalhes && Object.keys(r.detalhes).length > 0 && (
                    <span style={{ color:'#9ca3af', marginLeft:6 }}>{JSON.stringify(r.detalhes).substring(0,60)}</span>
                  )}
                </div>
                <div style={{ color:'#9ca3af', fontFamily:'monospace', fontSize:11 }}>{r.ip||'—'}</div>
              </div>
            ))
        }
      </div>

      {total > 50 && (
        <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:16 }}>
          <button onClick={() => setPagina(p=>Math.max(1,p-1))} disabled={pagina===1}
            style={{ padding:'6px 14px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>← Anterior</button>
          <span style={{ padding:'6px 14px', fontSize:13, color:'#6b7280' }}>Página {pagina} de {Math.ceil(total/50)}</span>
          <button onClick={() => setPagina(p=>p+1)} disabled={pagina>=Math.ceil(total/50)}
            style={{ padding:'6px 14px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>Próxima →</button>
        </div>
      )}
    </Layout>
  )
}
